export default __webpack_public_path__ + "static/media/alcatraz.17a84e08.jpg";